export const DEFAULT_API_ITEM_LIMITS = {
  JOBS_API: 50,
  PROJECTS_API: 50,
  REGIONS_API_ITEM_LIMITS: 50,
  RETAILERS_API_ITEM_LIMITS: 50,
  IMPORT_LOGS_API_ITEM_LIMITS: 50,
  PRODUCTS_API_ITEM_LIMITS: 50,
}

export const FILTER_IDS = {
  PROJECT_MANAGER: 'projectManagerFilters',
  PROJECT_IMPORT_LOGS: 'projectImportLogsFilters',
  TASK_MANAGER: 'taskManagerFilters',
  PROJECT_SUMMARY: 'projectSummaryFilters',

  // TODO: deprecated, to be removed in CMCST-899 & CMCST-916
  CLIENT_AND_BRAND_PROJECT: 'clientAndBrandProjectFilters',
  CLIENT_AND_BRAND_TASK: 'clientAndBrandTaskFilters',
} as const

export type FilterId = (typeof FILTER_IDS)[keyof typeof FILTER_IDS]

// Commerce Studio Entity keys
export const ENTITY_KEYS = {
  CLIENT: 'client',
  BRAND: 'brand',
  RETAILER: 'retailer',
  REGION: 'region',
  JOB: 'job',
  PROJECT: 'project',
} as const

// Banner keys
export const BANNER_KEYS = {
  SETTINGS_HOME: 'settings-home',
  DELETE_SUCCESS: {
    CLIENT: 'delete-client-success',
    BRAND: 'delete-brand-success',
    REGIONS: 'delete-region-success',
    RETAILER: 'delete-retailer-success',
    PROJECT: 'delete-project-success',
  },
  RESTORE_SUCCESS: {
    BRAND_VERSION: 'restore-brand-version-success',
    RETAILER_VERSION: 'restore-retailer-version-success',
  },
} as const

// Map to show the correct entity key for the delete success banner
export const bannerEntityMap = new Map([
  [BANNER_KEYS.DELETE_SUCCESS.CLIENT, ENTITY_KEYS.CLIENT],
  [BANNER_KEYS.DELETE_SUCCESS.BRAND, ENTITY_KEYS.BRAND],
  [BANNER_KEYS.DELETE_SUCCESS.REGIONS, ENTITY_KEYS.REGION],
  [BANNER_KEYS.DELETE_SUCCESS.RETAILER, ENTITY_KEYS.RETAILER],
])

export const ERROR_MESSAGES = {
  MANDATORY_FIELD: 'This is a mandatory field',
  NUMERIC_FIELD: 'This field should be a number',
  RETAILER_ID: 'Value must be lowercase and alphanumeric, only underscores and hyphens are allowed',
  ESSENTIAL_FIELD: 'This is a mandatory field, you cannot save a product without it',
}

export const WARNING_MESSAGES = {
  NON_EMPTY_KEYWORD: 'Press "Enter" to add the Keyword',
}

export const REGEX_PATTERNS = {
  NUMERIC: /^\d+$/,
  ALPHANUMERIC: /^[a-z0-9_-]+$/,
}

export const SEARCH_PARAMETERS = {
  DELETE_PROJECT: 'deleted_project',
}

export const BANNER_TIMEOUT = 10000
export const MANUAL_UPLOAD_FILE_LIMIT_SIZE = 50000000

export const LOCAL_STORAGE_KEYS = {
  FILTERS_EXPANSION_CONFIG: 'CS_FILTERS_EXPANSION_CONFIG',
}

export const MAX_FILE_SIZES_MB = {
  TASK_UPLOAD: 50,
}

export const EXTERNAL_LINKS = {
  WPP_OPEN_HOME: 'https://wpp.os.wpp.com/home',
}

export const PDP_GENERATOR_API_HEADERS = {
  WPP_OPEN_WORKSPACE_ID_HEADER: 'x-workspace-id',
  CLIENT_IDS_HEADER: 'x-client-ids',
}

export const unknown = 'Unknown'
